module.exports = __webpack_public_path__ + "img/tema-1-16.40b7427b.png";